function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".close_svg__cls-1{stroke-miterlimit:10;stroke-width:2px}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "close_svg__cls-1",
  d: "M.71.71l18 18M18.71.71l-18 18"
});

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 19.41 19.41"
  }, props), _ref, _ref2);
};

export default SvgClose;